import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { TenantDocumentView } from "./TenantDocumentView";
import { TenantDocumentViewStore } from "../../store/TenantDocumentViewStore";
import { useStore } from "../../../../hooks";

export const TenantDocumentViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/tenantDocument/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new TenantDocumentViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <TenantDocumentView tenantDocumentViewStore={store} />
      </PageLayout>
    </div>
  );
});
